export { default } from './card-information.component';
